module.exports = __webpack_public_path__ + "static/002_body-landscape-b26bcc42285e69b243dc400cd05d973f.mp4";